export default "__VITE_ASSET__Cwuz6wAi__"